export default {
    init() {
    },
    finalize() {

        if (window.innerWidth >= 1024) {
            document.querySelector('.woocommerce-MyAccount-navigation-link').classList.add('is-active');
        }

        jQuery('#password_1').after("<span id='password_strength' class='woocommerce-password-strength'></span>");

        jQuery("#password_1").keyup(function(e){

            window.checkPasswordStrength(jQuery(this),jQuery('#password_strength'), [], jQuery('form.edit-account button'), true );

        });
    }
};



// WEBPACK FOOTER //
// ./js/routes/woocommerce-account-dashboard.js